import React, { useEffect, useState } from 'react'
import styles from '../../styles/casestudy.module.css'
import Image from 'next/image'
import TestimonialSection from '../common/TestimonialSection'
import { testimonialData, videoTestimonial } from '@/constants/common'
import content from '../../language/ENGLISH.json'
import PersonalisedDemoBanner from '../common/PersonalisedDemoBanner'
import VerificationPopup from '../modals/VerificationPopup'
import TrustFactor from '../common/TrustFactor'
import FrequentQuestions from '../homePage/FrequentQuestions'
import { useRouter } from 'next/router'
import MobileTestimonialSection from '../common/MobileTestimonialSection'
import FAQ_mobile from '../Industry/FAQ_mobile'
import MobilePDBanner from '../common/MobilePDBanner'

const HUL = () => {
    const { testimonialHeadText } = content.testimonial;
    const [demoModal, setDemoModal] = useState(false);
    const [formHeading, setHeading] = useState("Book your free demo now!");
    const [mobileView, setmobileView] = useState(0);
    const router = useRouter()

    const setWindowDimensions = () => {
        window.innerWidth > 600 ? setmobileView(0) : setmobileView(1);
    };

    useEffect(() => {
        setWindowDimensions();
        window.addEventListener("resize", setWindowDimensions);
        return () => {
            window.removeEventListener("resize", setWindowDimensions);
        };
    }, []);

    const engagementSnap = [
        {
            title: <><b>100</b> sub stockists <br />  within <b>3 weeks</b></>,
            tag: "Pilot Phase",
            tagColor: "#C9F6FF",
            bgColor: "#EDFBFE",
            width: "44%",
            mobileWidth: "48%"
        },
        {
            title: <><b>4000+</b> sub stockists <br />with in <b>6 weeks</b></>,
            tag: "Rollout Phase",
            tagColor: "#F8D378",
            bgColor: "#FFF6E4",
            width: "54%",
            mobileWidth: "49%"
        },
        {
            title: <><b>9</b> Integrations </>,
            tag: "Integrations",
            tagColor: "#87F1D5",
            bgColor: "#EDFEF9",
            width: "54%",
            mobileWidth: "48%"
        },
        {
            title: <><b>100% visibility</b> of SKU <br /> movements</>,
            tag: "Outcome",
            tagColor: "#EEC9FF",
            bgColor: "#FCF7FF",
            width: "44%",
            mobileWidth: "49%"
        }
    ]

    const qbPOS = [
        {
            title: "RealTime Insights",
            description: "Real-time visibility and insights for better decision-making.",
            icon: "/assets/caseStudy/hul/realtime-insights.svg"
        },
        {
            title: "Robust Software",
            description: "A powerful, flexible solution tailored for complex supply chains.",
            icon: "/assets/caseStudy/hul/robust-software.svg"
        },
        {
            title: "Seamless integration",
            description: "Smaff integration with your current systems to ensure operations are done without hitches.",
            icon: "/assets/caseStudy/hul/integration.svg"
        },
        {
            title: "Exceptional Support",
            description: "A dedicated customer support team to ensure operations are done seamlessly.",
            icon: "/assets/caseStudy/hul/support.svg"
        },
    ]
    const faqs = [
        {
            para: (
                <span style={{ width: "90%" }}>
                    How did QueueBuster POS help HUL achieve real-time visibility of SKU movements?
                </span>
            ),
            des: "It automated sub-stockist automation with QueueBuster POS, having a full-proof end-to-end tracking system that gives real-time visibility into the movements of SKUs. It was rolled out in over 4,000 sub-stockists, which helped HUL trace the movement of goods, starting from the distributor, up to the sub-stockists, and then toward the Kirana stores. The system flawlessly integrated with HUL's existing ICT infrastructure, and thus was in a position to capture and report real-time data and information directly. It is in this regard that HUL was able to view how shifts were fairing in terms of stock management and consequently replenishment, making an extra effort to respond promptly to the needs dictated by changes in demand so that products were where they were needed. Such visibility in real time was absolutely important for accurate forecasting and, as such, strategic planning in a bid to realize improved sales as well as customer service.",
            id: 1,
            activeIndex: 1,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What specific challenges did HUL face before implementing QueueBuster POS?
                </span>
            ),
            des: "Before the implementation of QueueBuster POS, HUL had very limited visibility on the tertiary channels of supply. This lack of transparency made it impossible for the company to trace the movement of its SKUs beyond the distributor level. The result was frequent stock outs, over stockings, inefficiencies in inventory management, and demand forecasting. Quick insights into the consumption pattern across regions had always posed a challenge for HUL, hampering its ability to plan and strategize the execution of its marketing strategies. Without an effective tracking mechanism, the inability to correlate operational inputs and results further precipitated an overall poor business performance.",
            id: 2,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How did QueueBuster POS address the integration needs of HUL's existing systems?
                </span>
            ),
            des: "The architecture of the QueueBuster POS system was such that it could easily integrate with all previous systems of HUL, providing minimal or no disturbance at the time of deployment. The integration process had nine different touchpoints to connect QueueBuster POS to the existing HUL infrastructure. Integration was such that it was able to pass real-time data between QueueBuster POS and the HUL ERP system to synchronize inventory updates, automate order processing, and centralize reporting. The team coordinated with HUL to accommodate the company's requirements regarding data formats, communication protocols, and security in order to guarantee a smooth transition that helped the company run its business operations more efficiently.",
            id: 3,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    When was QueueBuster POS deployed, and what was the way it was rolled out?
                </span>
            ),
            des: "QueueBuster POS was deployed for HUL in two phases. We had the pilot phase of 100 sub-stockists that took three weeks. This was an important step to test whether the system could sustain its functionality and meet HUL's expectations. Once pilot went off successfully it was rolled out to over 4000+ sub-stockists within a period of six weeks. The whole program was honestly well planned and managed to minimize any disruptions. A team from QueueBuster worked closely with the HUL staff in providing training means, support activities, and troubleshooting to ensure that things went smooth. The integrations and system adjustments took eight weeks from end to end.",
            id: 4,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    Which features of QueueBuster POS drove the project's success?
                </span>
            ),
            des: "There were several key features of QueueBuster POS that had a great bearing on the success of HUL's sub-stockists automation project. These features covered real-time SKU tracking that allowed immediate visibility in the movement of products, automated inventory management to reduce manual errors and to increase stock accuracy, and comprehensive reporting tools to provide actionable insights into the sales and consumption pattern. In addition, the scalability of the system was huge enough to withstand the large volume of data produced by more than 4,000 sub-stockists, and its user-friendly interface made it easy for the sub-stockists to adapt and use with great effect. A little more configurational robustness and interfacing capability of QueueBuster POS had ensured flawless communication with the existing systems of HUL, and hence their operational efficiency kept on increasing.",
            id: 5,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How did QueueBuster POS improve business planning and forecasting for HUL?
                </span>
            ),
            des: "QueueBuster POS provided a good effect in business planning and forecasting facilities for HUL through the real-time availability of data on the movement of SKUs and inventory levels, respectively. Accurate and up-to-date information on the availability of stock items, consumption trends, and the like could enable HUL to undertake well-informed decisions on production schedules, distribution strategies and the perfect tagline and approach for marketing campaigns. HUL could use its exhaustive reporting tools to cull sales data on the various regions and product categories, analyze them for patterns and trends, and course-correct their plans accordingly. This enhanced the visibility and actionable transparency of data for HUL to optimize the supply chain processes and reduce wastages, ensuring that products were available at any point to serve the customer demand.",
            id: 6,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What was the kind of support that QueueBuster provided both during and after deployment?
                </span>
            ),
            des: "QueueBuster provided total support throughout deployment as well as post-deployment. In the implementation stage, a dedicated project team worked with HUL to ensure the right setup of the system and integration points were working as required. The team also trained the HUL and sub-stockists' staff on-site in order to bring them up to speed in using the new system. QueueBuster continued to offer support after deployment through a dedicated helpdesk available to address any issues or questions. Regular system updates and maintenance kept QueueBuster POS relevant to the ongoing operational needs of HUL.",
            id: 7,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    How did HUL's sub-stockists respond to the implementation of QueueBuster POS?
                </span>
            ),
            des: "The response from HUL's sub-stockists to the implementation of QueueBuster POS was overwhelmingly positive. The user-friendly interface and intuitive design of this system is very easy to adapt to sub-stockists. They liked automated inventory management and real-time tracking features, which were very useful in saving time and reducing the effort involved in stock checks and record-keeping. The system also offered increased visibility into their own operations, letting them manage their inventory effectively and respond with improved swiftness to change in demand. On the whole, QueueBuster POS accomplished increased efficiency and productivity for HUL's sub-stockists.",
            id: 8,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What metrics would evaluate the success of the QueueBuster POS deployment for HUL?
                </span>
            ),
            des: "The metrics against which the success of QueueBuster POS deployment for HUL would be measured include the accuracy and timeliness in tracking all SKUs, improvement in the efficiency of inventory management, and the ebullition of stock-out and overstock situations. Some other of the key metrics were the velocity of integration; effectiveness with HUL's existing system; duration of deployment; and level of user adoption and user satisfaction in the channel of the sub-stockists. HUL used to measure the overall effect of the system on their business performance: increased sales, improved levels of customer satisfaction, and a higher level of accuracy in business planning and forecasting.",
            id: 9,
            activeIndex: 0,
        },
        {
            para: (
                <span style={{ width: "90%" }}>
                    What are HUL's plans to further deploy QueueBuster POS?
                </span>
            ),
            des: "Given the success of the pilot rollout, HUL has future plans to further extend the use of QueueBuster POS within their broader supply chain. This would mean extending the system to other sub-stockists as well as incorporating it into more aspects of their operations. The company is also considering the possibility of using QueueBuster POS to keep an eye on and manage other parts of its supply chain, including production and distribution processes. Further, HUL is eyeing the way advanced analytics and machine learning capabilities will be implemented to give more insight into data captured by QueueBuster POS, further sharpening its business planning and decision-making processes.",
            id: 10,
            activeIndex: 0,
        },
    ]
    return (
        <>
            <div className={styles.verificationPopupOverride}>
                <VerificationPopup isOpen={demoModal} closeModal={() => setDemoModal(false)} formHeading={formHeading} />
            </div>
            <div className={styles.hero_section}>
                {
                    mobileView ?
                        <div className={styles.mobile_hero_img} style={{ backgroundImage: "url('/assets/caseStudy/hul/hul_mobile_hero_img.webp')" }}>
                            <div>
                                <h1>How <span className={styles.blue_text}>QueueBuster</span> Improved HUL's SKU Visibility by 100%</h1>
                                <div className={styles.hero_content}>
                                    <div>
                                        <p>9</p>
                                        <p>Number of Integrations</p>
                                    </div>
                                    <div>
                                        <p>67%</p>
                                        <p>Stock Monitoring Enhancement</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        :
                        <div className={styles.hero_section_inner_container}>
                            <div className={styles.hero_section_image}><Image src="/assets/caseStudy/hul/hul_desktop_hero_img.webp" alt="hul hero image" fill /></div>
                            <div className={styles.hero_heading1}><h1>How QueueBuster Improved HUL's SKU Visibility by 100%</h1></div>
                            <div className={styles.hero_content}>
                                <div>
                                    <p>9</p>
                                    <p>Number of Integrations</p>
                                </div>
                                <div>
                                    <p>67%</p>
                                    <p>Stock Monitoring Enhancement</p>
                                </div>
                                <div>
                                    <p>100%</p>
                                    <p>Mapping of Sub Stockist</p>
                                </div>
                            </div>
                        </div>
                }
                <div className={styles.light_blue_box}>
                    <div>
                        <p>About HUL</p>
                        <p>Hindustan Unilever Limited is one of the top FMCG companies with a presence of over 50 product brands across 20+ consumer categories and annual revenues of over ₹51,000 Crores.</p>
                    </div>
                    <div>
                        <p>Deployed Solution</p>
                        <p>QueueBuster POS was deployed over 4000+ sub-stockists to provide real-time SKU tracking right from distributors to sub-stockists to Kirana stores.</p>
                    </div>
                </div>
                <div className={styles.owner_words}>
                    <p>“QueueBuster helped us automate our sub-stockists network with a world-class product, and with the stupendous customer support team to back this up. We entered our 5th year of relationship with them in 2023.”</p>
                    <p className={styles.name}>Mr. Pikustar Borah</p>
                    <p className={styles.position}>Technology Lead, South Asia, HUL</p>
                </div>
            </div >
            <div className={styles.section_two}>
                <div>
                    <div className={styles.problem_statement}>
                        <p className={styles.orange_heading}>Problem Statement</p>
                        <p>HUL needed better visibility of SKU movements than what was available with the distributors, who sell across tertiary channels beyond the distributor levels, which hampered their visibility on real-time demand and consumption.</p>
                        <p className={styles.green_heading}>Outcomes</p>
                        <ul>
                            <li><b>Real-Time Tracking:</b> Allowed HUL the ability to track demand and consumption of multiple SKUs in real-time across different regions.</li>
                            <li><b>Better Planning:</b> This, in turn, led to better planning and business forecasting.</li>
                            <li><b>Full Visibility:</b> 100% visibility of SKU movements across the substockists network.</li>
                        </ul>
                    </div>
                    <div className={styles.blue_box}>
                        <div className={styles.client_img}><Image src="/assets/caseStudy/hul/hul.svg" alt="hul" fill /></div>
                        <div className={styles.row}>
                            <p className={styles.light_heading}>Industry Type</p>
                            <p>Fast-Moving Consumer Goods (FMCG)</p>
                        </div>
                        <div className={styles.row} style={{ display: "flex", gap: "3rem" }}>
                            <div>
                                {/* <p className={styles.light_heading}>Type of Business</p> */}
                                {/* <p>Products</p> */}
                            </div>
                            <div>
                                {/* <p className={styles.light_heading}> FMCG</p> */}
                                {/* <p>300+</p> */}
                            </div>
                        </div>
                        <div className={styles.row}>
                            <p className={styles.block}>Inventory Management</p>
                            <p className={styles.block}>CRM & Loyalty</p>
                            <p className={styles.block}>Digital Payments</p>
                            <p className={styles.block}>Cloud Dashboard</p>
                            <p className={styles.block}>Billing/Invoices</p>
                        </div>
                    </div>
                </div>
                <div>
                    <p className={styles.pink_heading}>Engagement Snapshot</p>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
                        {
                            engagementSnap?.map((ele) => {
                                return (
                                    <div style={{ backgroundColor: ele?.bgColor, width: mobileView ? ele?.mobileWidth : ele?.width, padding: mobileView ? "1.5rem" : "3.75rem", borderRadius: "1rem" }}>
                                        <p style={{ font: mobileView ? "normal normal normal 1.8rem/3rem Inter" : "normal normal normal 2.4rem/3rem Inter" }}>{ele?.title}</p>
                                        <div style={{ backgroundColor: ele?.tagColor, padding: "1rem 2rem", borderRadius: "70px", width: "fit-content", marginTop: "2rem" }}>{ele?.tag}</div>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
            <div className={styles.qb_POS}>
                <h3>Why Choose QueueBuster POS?</h3>
                <div className={styles.qb_POS_container}>
                    {
                        qbPOS?.map((ele) => {
                            return (
                                <div>
                                    <div style={{ height: "5rem", width: "5rem", position: "relative", margin: "2rem auto" }}><Image src={ele?.icon} alt={ele?.title} fill /></div>
                                    <p style={{ font: "normal normal 500 1.8rem/2.6rem Inter", textAlign: "center" }}>{ele?.title}</p>
                                    <p style={{ font: "normal normal normal 1.4rem/2rem Inter", textAlign: "center", color: "#6F7F96" }}>{ele?.description}</p>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            <div className={styles.supply_chain}>
                <div>
                    <h4>Transform Your Supply Chain with QueueBuster POS</h4>
                    <p>QueueBuster POS is dedicated to providing innovative solutions that streamline operations, enhance visibility across the supply chain, and with our powerful software, businesses like HUL are able maintain better planning, forecasting, and overall efficiency.</p>
                </div>
                <div style={{ height: mobileView ? "15rem" : "20rem", width: mobileView ? "27rem" : "35rem", position: "relative" }}><Image src="/assets/caseStudy/hul/supply_chain.webp" alt="upply Chain with QueueBuster POS" fill /></div>
            </div>

            <div className={styles.other_components}>
                <div className={styles.section_heading}><h3>{testimonialHeadText}</h3> <div className={styles.heading_stroke}><Image src='/assets/strokes_svg/testimonials_hl.svg' alt='industries' fill /></div></div>
                {
                    mobileView ? <MobileTestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} /> :
                        <TestimonialSection testimonialData={testimonialData} videoTestimonial={videoTestimonial} />
                }
            </div>
            <div className={styles.other_components}>{
                mobileView ? <MobilePDBanner setDemoModal={setDemoModal} setHeading={setHeading} /> : <PersonalisedDemoBanner setDemoModal={setDemoModal} setHeading={setHeading} />
            }</div>
            <div style={{ margin: mobileView ? "0 3rem" : "0 5rem" }}><TrustFactor /></div>
            <div>{
                mobileView ?
                    <FAQ_mobile FaqTableData={faqs} width={"auto"} heading={"Frequently Asked Questions"} />
                    :
                    <FrequentQuestions FaqTableData={faqs} heading={"Frequently Asked Questions"} />
            }</div>
        </>
    )
}

export default HUL